import { namespace } from 'vuex-class';
import { IMoveResourceState } from './move-resource.types';

export const MoveResource = namespace('contentLibrary/moveResource');

export enum EMoveResourceAction {
  Load = 'load',
  LoadSuccess = 'loadSuccess',
  LoadFailed = 'loadFailed',
  Move = 'move',
  MoveSuccess = 'moveSuccess',
  MoveFailed = 'moveFailed',
  Reset = 'reset',
}

export enum EMoveResourceMutation {
  SetLoaded = 'setLoaded',
  SetLoading = 'setLoading',
  SetResource = 'setResource',
  SetMoving = 'setMoving',
  SetMovedResource = 'setMovedResource',
  SetState = 'setState',
}

export const state: IMoveResourceState = {
  loaded: false,
  loading: false,
  resource: null,
  moving: false,
  movedResource: null,
};
